import ApiRequests from "../apiRequests";

class ImageService extends ApiRequests {
  constructor() {
    super("upload");
  }
}

export default ImageService;
